<template>

  <v-container >
    

    <v-layout row wrap justify-center >
      <v-flex >
       <h1 class="ma-5">404 NOT FOUND PAGE!</h1>
      </v-flex>
    </v-layout>

    
  </v-container>
</template>

<script>
export default {
  data () {
    return {
 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/error.vue